export function isDev() {
    return process.env.MODE === "development" || window.location.hostname.includes('localhost');
}